module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Work/Projects/OnlineParser/web2-ui/src/app/admin/admin.component.html
// module id = ../../../../../src/app/admin/admin.component.html
// module chunks = main